<template>
  <span v-if="description" class="vanguard-description">
    <!-- Cf. VanguardLabel.vue pour la rationale plainText vs v-html. -->
    <template v-if="plainText">{{ plainDescription }}</template>
    <span v-else v-html="renderHTML(description)"></span>
  </span>
</template>

<script>
import { stripDecodedHtml } from "@/services/text";

export default {
  name: "ChoiceVanguardDescription",
  props: {
    choice: {
      type: Object,
    },
    plainText: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    description() {
      // This is computed because choice may change after init
      return this?.choice?.vanguardDescription;
    },
    plainDescription() {
      return stripDecodedHtml(this.description);
    },
  },
};
</script>
